export default __webpack_public_path__ + "static/media/sendgrid.e181789e.svg";